import type { FileEntityType } from '@core/types/file';
import { pluralize } from '@core/utils/pluralize';
import type { MakeToastBuilderReturn } from '@web/providers/ToastProvider/utils/makeToastBuilder';

import type { FileUploadsManager } from './useFileUploads';

export const attachBufferedEntityFiles = (
  manager: FileUploadsManager,
  entityId: string,
  toast: MakeToastBuilderReturn,
  entityType: FileEntityType,
): void => {
  if (!manager.hasAttachableItems && !manager.hasPendingUploads) {
    return;
  }

  manager
    .attachAll(entityId)
    .then(({ failedFileNames }) => {
      if (failedFileNames.length === 0) {
        return;
      }
      toast.error({
        message: `Failed to attach ${pluralize(failedFileNames.length, 'file')} to ${entityType}: ${failedFileNames.join(', ')}`,
      });
    })
    .catch(() => {
      toast.error({
        message: `Failed to attach files to ${entityType}. Try again from the Files tab.`,
      });
    });
};
